import React, { ReactNode, FC } from 'react';
import { IMeta } from '../types/elements';
import { takeGoogleFontsUrl } from '../utils/takeGoogleFontsUrl';
import { IBreadcrumb } from '../sections/BreadCrumbs';

const SEO: FC<{
  meta: IMeta;
  breadcrumbsSchema?: IBreadcrumb[];
  gtmCode: string;
  fonts: { label: string; value: string }[];
  children?: ReactNode;
  iconUrl: string;
}> = ({ fonts, meta, breadcrumbsSchema, children, gtmCode, iconUrl }) => {
  return (
    <>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="icon" href={iconUrl} />
      <meta
        name="robots"
        content={`${meta?.noindex ? 'noindex' : 'index'}, ${meta?.nofollow ? 'nofollow' : 'follow'}`}
      />
      {/* Google Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preload" href={takeGoogleFontsUrl(fonts)} as="style" />
      <link href={takeGoogleFontsUrl(fonts)} rel="stylesheet" />
      {/* End Google Fonts */}

      <script>
        {`
            function gtag() {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push(arguments);
            }
            
            let consents = {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                analytics_storage: 'denied',
                functionality_storage: 'denied',
                personalization_storage: 'denied',
                security_storage: 'denied',
            }
            
            const cookies = document.cookie
                ? document.cookie
                    .split(";")
                    .map((v) => v.split("="))
                    .reduce((acc, v) => {
                        acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(
                            v[1].trim()
                        );
                        return acc;
                    }, {})
                : null;
                
            if (cookies?.cookieConsent){
                let cookieConsentJSON = {}
                let cookieConsent = cookies.cookieConsent
                cookieConsent = cookieConsent.replace(/{|}| |'|"/g, '').split(",")
                for(var i = 0; i < cookieConsent.length; i++){
                    cookieConsentJSON[cookieConsent[i].split(":")[0]] = cookieConsent[i].split(":")[1]
                }
                consents = cookieConsentJSON;
            }                       
        
            gtag("consent", "default", consents);                  
        `}
      </script>

      {/* Google Tag Manager */}
      <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmCode}');`}</script>
      {/* End Google Tag Manager */}

      {breadcrumbsSchema && breadcrumbsSchema?.length > 0 ? (
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [${breadcrumbsSchema.map(
              (item, index) => `{
              "@type": "ListItem",
              "position": ${index + 1},
              "name": "${item.label}"
              ${item.link ? `, "item": "${item.link}"` : ''}
            }`,
            )}]
          }`}
        </script>
      ) : (
        ''
      )}

      {children}
    </>
  );
};

export default SEO;
